(function () {
  window.getUnitDimensionData = function (doorType, doorStyle, sizeCode, panelType, swing) {
    const map = window.UNIT_DIMENSION_MAP || {};
    const sizeNode =
      map[doorType] &&
      map[doorType][doorStyle] &&
      map[doorType][doorStyle][String(sizeCode)];

    if (!sizeNode) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    const panelNode = sizeNode[panelType];
    if (!panelNode) {
      return {
        unit_dimension: '',
        rough_opening: '',
        glass_dimension: ''
      };
    }

    const raw = panelNode[swing] || panelNode.all || '';

    // 舊格式：直接是字串
    if (typeof raw === 'string') {
      return {
        unit_dimension: raw,
        rough_opening: '',
        glass_dimension: ''
      };
    }

    // 新格式：物件
    if (raw && typeof raw === 'object') {
      return {
        unit_dimension: raw.unit_dimension || '',
        rough_opening: raw.rough_opening || '',
        glass_dimension: raw.glass_dimension || ''
      };
    }

    return {
      unit_dimension: '',
      rough_opening: '',
      glass_dimension: ''
    };
  };

  // 舊程式若還有地方呼叫 getUnitDimension，可保留相容
  window.getUnitDimension = function (doorType, doorStyle, sizeCode, panelType, swing) {
    const data = window.getUnitDimensionData
      ? window.getUnitDimensionData(doorType, doorStyle, sizeCode, panelType, swing)
      : { unit_dimension: '', rough_opening: '', glass_dimension: '' };

    return data.unit_dimension || '';
  };
})();